import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=8aecc3f2&scoped=true"
import script from "@/views/Webshop/OrderDetail/OrderTable.ts?vue&type=script&lang=ts&external"
export * from "@/views/Webshop/OrderDetail/OrderTable.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Webshop/OrderDetail/order-table.scss?vue&type=style&index=0&id=8aecc3f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aecc3f2",
  null
  
)

export default component.exports